import React, { useState, useEffect, useContext } from "react";
import MovieArtistSlider from "./MovieArtistSlider";
import MoviePosterSlider from "./MoviePosterSlider";
import axios from "axios";
import { Rings } from "react-loader-spinner";
import { MovieIndexContext } from "../../context/MovieIndexContext";

import "./Movies.scss";

const Movies = ({ setValue }) => {
  const [content, setContent] = useState([]);
  const [cast, setCast] = useState([]);
  const { movieId, changeEvent, loading, setLoading } =
    useContext(MovieIndexContext);
  // console.log("movieId ye 2 bar ", movieId);
  // console.log(content);

  const fetchedMoviesData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/trending/movie/week?api_key=${process.env.REACT_APP_API_KEY}`
    );
    // console.log("MovieList", data.results);
    setContent(data.results);
    setLoading(true);
  };

  const fetchedMoviesArtists = async () => {
    // console.log("content", content);
    // console.log("movieId", movieId);
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/movie/${content[movieId].id}/credits?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );
    setCast(data?.cast);
    setLoading(true);
  };
  useEffect(() => {
    // console.log("Ddd");
    fetchedMoviesData();
  }, []);
  useEffect(() => {
    if (content.length > 0 && movieId >= 0) fetchedMoviesArtists();
    // eslint-disable-next-line
  }, [movieId, content]);

  return (
    <div className="movies-tab">
      {loading ? (
        <MoviePosterSlider
          content={content}
          movieId={changeEvent}
          loading={loading}
        />
      ) : (
        <Rings width={1000} height={200} color="#a83119" />
      )}
      <div className="movies-tab__artist-section">
        <div className="movies-tab__best-artists-title">Best Artists</div>
        {loading ? (
          <MovieArtistSlider cast={cast} setCast={setCast} loading={loading} />
        ) : (
          <Rings width={1000} height={200} color="#a83119" />
        )}
      </div>
    </div>
  );
};
export default Movies;
